import React from 'react';
import { Controller } from 'react-hook-form';
import Tooltip from '@material-ui/core/Tooltip';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import styled from 'styled-components';
import Switch from '../../../Shared/Switch';
import { StyledQuestionFieldContainer } from '../../../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import { ClinicFormProps } from '../types';

const TOOLTIP_COPY =
  'When enabled, prescribers on this clinic will need to create a PIN in Connect before they can prescribe. When disabled, the clinic reverts to non-e-signature prescriptions.';

const EsignatureToggle = ({ form }: ClinicFormProps) => (
  <Controller
    control={form.control}
    name="esignature_enabled"
    render={({ field }) => (
      <StyledQuestionFieldContainer>
        <Switch
          checked={field.value}
          onChange={(_event: unknown, checked: boolean) => field.onChange(checked)}
          label={
            <LabelWithIcon>
              E-signature enabled
              <Tooltip title={TOOLTIP_COPY} placement="right">
                <InfoIcon />
              </Tooltip>
            </LabelWithIcon>
          }
          disabled={false}
          value={field.value}
          reverseOrder={false}
        />
      </StyledQuestionFieldContainer>
    )}
  />
);

const LabelWithIcon = styled.span`
  display: inline-flex;
  align-items: center;
`;

const InfoIcon = styled(InfoOutlinedIcon)`
  color: #757575;
  font-size: 18px;
  margin-left: 8px;
  cursor: help;
`;

export default EsignatureToggle;
